"use client";

import { Slider as BaseSlider } from "@base-ui/react/slider";
import { type ReactNode } from "react";

type RootProps = {
  value?: number | number[];
  defaultValue?: number | number[];
  min?: number;
  max?: number;
  step?: number;
  onValueChange?: (value: number | number[]) => void;
  onValueCommitted?: (value: number | number[]) => void;
  children?: ReactNode;
  className?: string;
};

function SliderRoot({
  value,
  defaultValue,
  min,
  max,
  step,
  onValueChange,
  onValueCommitted,
  children,
  className,
}: RootProps) {
  return (
    <BaseSlider.Root
      value={value}
      defaultValue={defaultValue}
      min={min}
      max={max}
      step={step}
      onValueChange={onValueChange}
      onValueCommitted={onValueCommitted}
      className={className}
    >
      {children}
    </BaseSlider.Root>
  );
}

function SliderControl({ children }: { children: ReactNode }) {
  return (
    <BaseSlider.Control className="flex w-full touch-none select-none items-center py-3">
      {children}
    </BaseSlider.Control>
  );
}

function SliderTrack({ children }: { children: ReactNode }) {
  return (
    <BaseSlider.Track className="h-1.5 w-full select-none rounded-full bg-disabled">
      {children}
    </BaseSlider.Track>
  );
}

function SliderIndicator() {
  return <BaseSlider.Indicator className="rounded-full bg-primary" />;
}

function SliderThumb({ index }: { index: number }) {
  return (
    <BaseSlider.Thumb
      index={index}
      className="size-5 select-none rounded-full bg-surface shadow-[0_0_0_2px_var(--color-primary)] outline-none focus-visible:shadow-[0_0_0_3px_var(--color-fg)]"
    />
  );
}

export const Slider = {
  Root: SliderRoot,
  Control: SliderControl,
  Track: SliderTrack,
  Indicator: SliderIndicator,
  Thumb: SliderThumb,
};
